export default function DownloadSection() {
  return (
    <section id="download" className="py-14 md:py-20 bg-background-900">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-3">
            立即下载东升大舞台
          </h2>
          <p className="text-background-300 text-sm md:text-base max-w-2xl mx-auto">
            选择您的设备平台，一键下载官方正版App，开启精彩演艺之旅
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
          <div className="bg-background-800/50 border border-background-700/50 rounded-lg p-6 md:p-8 text-center">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-accent-500/20">
              <i className="ri-android-line text-3xl text-accent-400"></i>
            </div>
            <h4 className="font-heading text-lg font-semibold text-background-50 mb-2">
              安卓版下载
            </h4>
            <p className="text-sm text-background-400 mb-6">
              支持 Android 8.0 及以上系统
            </p>
            <a
              href="#"
              className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-950 rounded-md text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-accent-400 transition-colors"
            >
              <i className="ri-download-line"></i>
              下载APK安装包
            </a>
            <p className="mt-4 text-xs text-background-500">
              版本 V3.5 | 大小 85MB | 安全检测通过
            </p>
          </div>

          <div className="bg-background-800/50 border border-background-700/50 rounded-lg p-6 md:p-8 text-center">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-accent-500/20">
              <i className="ri-apple-line text-3xl text-accent-400"></i>
            </div>
            <h4 className="font-heading text-lg font-semibold text-background-50 mb-2">
              iOS版下载
            </h4>
            <p className="text-sm text-background-400 mb-6">
              支持 iOS 14.0 及以上系统
            </p>
            <a
              href="#"
              className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-950 rounded-md text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-accent-400 transition-colors"
            >
              <i className="ri-download-line"></i>
              App Store 下载
            </a>
            <p className="mt-4 text-xs text-background-500">
              版本 V3.5 | 大小 210MB | 或通过TestFlight体验
            </p>
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-xs text-background-500">
            温馨提示：请通过本页面提供的官方渠道下载，以确保应用安全可靠。如遇下载问题，请联系客服 400-000-0000
          </p>
        </div>
      </div>
    </section>
  );
}